export default "__VITE_ASSET__BepvxRm1__"